import { useCallback, useEffect, useState } from "react"

import { popupApi } from "@shared/apis"
import { Popup } from "@shared/apis/popup"
import { useAccount, useSchedule } from "@shared/contexts"
import { getIsPopupClosed } from "@shared/modules"

export default function useRandomPopup(
  playerType: "VOD" | "LIVE",
): [Popup | undefined, (newPopup: Popup) => void] {
  const { schedule } = useSchedule()
  const { account } = useAccount()
  const [popup, setPopup] = useState<Popup>()

  const paymentInfo = schedule?.paymentInformation
  const streamerId = schedule?.user.id
  const role = account.viewer?.role

  const handlePopup = useCallback((newPopup: Popup) => {
    setPopup(newPopup)
  }, [])

  useEffect(() => {
    if (!paymentInfo || !streamerId || !role) return

    popupApi
      .random({
        exposedTarget: paymentInfo,
        targetPlayer: playerType,
        userId: streamerId,
        viewerRole: role,
      })
      .then(({ data: popup }) => {
        popup.isClosed = Boolean(getIsPopupClosed(popup.id))
        setPopup(popup)
      })
  }, [streamerId, paymentInfo, playerType, role])

  return [popup, handlePopup]
}
